/**
 * Navigatie-guard voor in-app navigatie (sidebar, terug-knoppen).
 *
 * De declaratieve router (<BrowserRouter>) heeft geen useBlocker; dit
 * registry is het lichte alternatief: een view met unsaved-changes
 * registreert een guard, en iedere plek die programmatic navigeert
 * (AppShell-sidebar, view-terugknoppen) vraagt eerst confirmNavigation().
 *
 * De guard retourneert `true` = navigatie toegestaan (de guard mag zelf
 * een window.confirm tonen). Hard verlaten (refresh / tab sluiten /
 * extern) blijft de taak van een `beforeunload`-listener in de view —
 * dat kán niet via dit registry.
 */

let guard: (() => boolean) | null = null;

/** Registreer een guard; de teruggegeven functie de-registreert 'm weer. */
export function registerNavigationGuard(fn: () => boolean): () => void {
  guard = fn;
  return () => {
    if (guard === fn) guard = null;
  };
}

/** True als navigeren mag (geen guard actief, of de guard staat het toe). */
export function confirmNavigation(): boolean {
  return guard === null || guard();
}
